import React, { useRef, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { InputText } from 'primereact/inputtext';
import { Password } from 'primereact/password';
import { Button } from 'primereact/button';
import AuthLayout, { AuthField, EMAIL_RE, EMAIL_ERR, PASS_ERR, validPass } from './AuthLayout';
import { usersApi } from '../api/services';
import { useAlerts } from '../custom/Alerts';

export default function Register() {
    const history = useHistory();
    const alerts = useAlerts();
    const [f, setF] = useState({ firstName: '', lastName: '', email: '', password: '', confirmPassword: '' });
    const [loading, setLoading] = useState(false);
    /* mamac za botove (backend users-controllers mamac): skriveno polje + vreme od otvaranja forme */
    const [adresaSajta, setAdresaSajta] = useState('');
    const otvoreno = useRef(Date.now());
    const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

    const errs = {
        firstName: !f.firstName && 'Ime je obavezno',
        lastName: !f.lastName && 'Prezime je obavezno',
        email: !EMAIL_RE.test(f.email) && EMAIL_ERR,
        password: !validPass(f.password) && PASS_ERR,
        confirmPassword: (!validPass(f.confirmPassword) && PASS_ERR) || (f.password !== f.confirmPassword && 'Lozinke se ne poklapaju'),
    };
    const valid = !Object.values(errs).some(Boolean);

    const submit = async (e) => {
        e.preventDefault();
        if (!valid) return;
        setLoading(true);
        try {
            const user = await usersApi.register({ firstName: f.firstName, lastName: f.lastName, email: f.email, password: f.password, adresaSajta, trajanje: Date.now() - otvoreno.current });
            alerts.success('Registracija uspešna. Aktivacioni email je poslat na Vašu e-mail adresu.');
            if (user.emailConfirmed) history.push('/login');
            else history.push('/verify', { user });
        } catch { /* toast */ }
        setLoading(false);
    };

    return (
        <AuthLayout title="Kreirajte nalog" description="Unesite podatke za registraciju.">
            <form onSubmit={submit} noValidate>
                <div className="auth-mamac" aria-hidden="true">
                    <input type="text" name="adresaSajta" tabIndex={-1} autoComplete="off" value={adresaSajta} onChange={(e) => setAdresaSajta(e.target.value)} />
                </div>
                <AuthField icon="bi-person" error={errs.firstName}>
                    <InputText placeholder="Ime" value={f.firstName} onChange={set('firstName')} />
                </AuthField>
                <AuthField icon="bi-person" error={errs.lastName}>
                    <InputText placeholder="Prezime" value={f.lastName} onChange={set('lastName')} />
                </AuthField>
                <AuthField icon="bi-envelope" error={errs.email}>
                    <InputText type="email" placeholder="E-mail adresa" value={f.email} onChange={set('email')} />
                </AuthField>
                <AuthField icon="bi-lock" error={errs.password}>
                    <InputText type="password" placeholder="Lozinka" value={f.password} onChange={set('password')} maxLength={50} />
                </AuthField>
                <AuthField icon="bi-lock" error={errs.confirmPassword}>
                    <InputText type="password" placeholder="Potvrdi lozinku" value={f.confirmPassword} onChange={set('confirmPassword')} maxLength={50} />
                </AuthField>
                <Button type="submit" label="Registracija" loading={loading} disabled={loading || !valid} />
            </form>
            <div className="auth-links center"><Link to="/login">Ulogujte se</Link></div>
        </AuthLayout>
    );
}
